module.exports = window["nab"]["experimentLibrary"];